module.exports = __webpack_public_path__ + "img/playground_thumb.300427c6.jpg";